module.exports = __webpack_public_path__ + "images/blogcard_store_badge_e6e7580d5e03b571ddf40f022e77c165.png";